import { render, staticRenderFns } from "./blog_group.vue?vue&type=template&id=2abf55f1"
import script from "./blog_group.vue?vue&type=script&lang=js"
export * from "./blog_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports